import { render, staticRenderFns } from "./GetItems.vue?vue&type=template&id=ed4d3a64&"
import script from "./GetItems.vue?vue&type=script&lang=js&"
export * from "./GetItems.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports